import React, { useState, useEffect, useContext, Fragment } from "react";
import * as Icon from "@phosphor-icons/react";

import { SsoContext } from "../../../_Contexts/ssoContext.jsx";

import SsoAccountCreate from "./sso-account-create.jsx";

import { AppName, SsoIdBranding } from "../../../../Common/constants.js";
import idMaker from "./../../../../../Assets/Images/id-maker-logo.png";
import "./../../../../../Styles/form.css";
import "./login-form.css";

function LoginForm() {
    const sso = useContext(SsoContext);

    const [company, setCompany] = useState({ id: 0 });
    const [username, setUsername] = useState("");
    const [password, setPassword] = useState("");

    const [uiState, setUiState] = useState("");

    useEffect(getCompany, []);

    const getReturnUrl = () => {
        const urlParams = new URLSearchParams(window.location.search);
        const normalized = {};
        for (const [key, value] of urlParams.entries())
            normalized[key.toLowerCase()] = value;

        return normalized["returnurl"] || "/";
    };

    function getCompany() {
        fetch("/company/info", {
            method: "GET",
        })
            .then(async (response) => {
                return await response.json();
            })
            .then((response) => {
                if (response.success)
                    setCompany(response.company);
            })
            .catch((error) => {
                console.error("Login error:", error);
            })
    }

    function logIn(event) {
        event.preventDefault();

        if (validFields()) {
            const loginData = {
                username: username,
                password: password,
                returnUrl: function () {
                    let returnUrl = "";
                    const urlParams = new URLSearchParams(window.location.search);
                    const foundReturnUrl = urlParams.get("ReturnUrl");
                    if (foundReturnUrl != null)
                        returnUrl = foundReturnUrl;

                    return returnUrl;
                }()
            };

            fetch("/account/login", {
                method: "POST",
                body: JSON.stringify(loginData),
                headers: {
                    "Content-type": "application/json; charset=UTF-8",
                    "dataType": "json"
                }
            })
                .then(response => response.json())
                .then(json => {
                    if (json.user)
                        window.location.href = json.returnUrl;
                })
                .catch(error => console.log(error));
        }
        else {
        }
    }

    const logInSso = (mode) => {
        let url = `/account/generatessourl?redirectafterlogIn=${getReturnUrl()}`;
        if (mode)
            url = `${url}&mode=${mode}`;

        fetch(url, {
            method: "POST",
            headers: {
                "Content-Type": "application/json; charset=utf-8"
            }
        })
            .then(async (res) => {
                if (!res.ok) {
                    setUiState("dataEntry");
                }
                return await res.json();
            })
            .then((data) => {
                window.location.href = data.url;
            })
            .catch((err) => {
                console.error("Login error:", err);
                setUiState("dataEntry");
            });
    };

    function validFields() {
        let isValid = true;

        let error = "";
        if (username.trim() === "") {
            error = "Please enter your username.";
            isValid = false;
        }
        else if (password.trim() === "") {
            error = "Please enter your password.";
            isValid = false;
        }

        return isValid;
    }

    function closeSsoAccountCreate() {
        setUiState("dataEntry");
    }

    return (
        <div styleName="login-background">
            <div styleName={`main-container ${uiState === "ssoAccountCreation" ? "login-container--sso" : ""}`}>
                <div styleName="login-form">
                    <div styleName="website-name"> <img src={idMaker} styleName="logo" alt="ID Maker" /> {AppName}</div>
                    {
                        sso !== null && !sso?.ssoEnabled &&
                        <form>
                            <div styleName="content">
                                <div styleName="input-field">
                                    <input type="text"
                                        id="username"
                                        placeholder="Username"
                                        aria-describedby="username"
                                        name="username"
                                        value={username}
                                        onChange={e => setUsername(e.target.value)}
                                        onKeyDown={(e) => { if (e.key === "Enter") logIn(e) }}
                                        required
                                        autoFocus
                                    />
                                </div>
                                <div styleName="input-field">
                                    <input type="password"
                                        id="password"
                                        placeholder="Password"
                                        aria-describedby="password"
                                        name="password"
                                        value={password}
                                        onChange={e => setPassword(e.target.value)}
                                        onKeyDown={(e) => { if (e.key === "Enter") logIn(e) }}
                                        required
                                    />
                                </div>
                            </div>
                            <div styleName="action">
                                <button type="submit" onClick={logIn} >Sign in</button>
                            </div>
                            <a href="/account/forgot" styleName="link">Forgot username or password?</a>
                        </form>
                    }
                    {
                        uiState === "ssoAccountCreation" &&
                        <SsoAccountCreate company={company}
                            returnUrl={getReturnUrl()}
                            cancel={closeSsoAccountCreate}
                        />
                    }
                    {
                        sso !== null && sso?.ssoEnabled && uiState !== "ssoAccountCreation" &&
                        <Fragment>
                            <div styleName="login">
                                <span styleName="action-msg">Log in with your {SsoIdBranding} <Icon.IdentificationBadge styleName="id-icon" color="#ffb200" weight="fill" size={20} /></span>
                                <button styleName="login-form__button login-form__button--highlight" onClick={logInSso}>Login</button>
                            </div>
                            <div styleName="create">
                                <span styleName="create-msg">Don't have a {SsoIdBranding}? </span>
                                <span styleName="create-link" onClick={() => setUiState("ssoAccountCreation")}>Create an ID</span>
                            </div>
                            <div styleName="connect">
                                <span styleName="create-msg">You have a {SsoIdBranding} and need to connect an account? </span>
                                <span styleName="create-link" onClick={() => logInSso("connect")}>Connect</span>
                            </div>
                            <a href="" styleName="link">Recover your old account</a>
                        </Fragment>
                    }
                </div>

            </div>

        </div>
    );
}

export default LoginForm